var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-header-tab"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      attrs: {
        "title": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.value) + "\n    ")])
  }), _vm._v(" "), _c('span', [_vm._v("Total AWBs (FM+LM) Added to Trip: " + _vm._s(_vm.FMcount + _vm.LMcount))])], 2), _vm._v(" "), _c('keep-alive', [(_vm.showTabs) ? _c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    ref: "moveToNext",
    tag: "component",
    staticClass: "tab",
    attrs: {
      "parentOBJ": _vm.parentOBJ
    },
    on: {
      "getFMcount": _vm.saveFMCount,
      "getLMcount": _vm.saveLMCount
    }
  }) : _vm._e()], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b283edd4","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/TripShipment/TripShipment.component.html
// module id = 1339
// module chunks = 3